import { Translate } from "../../constant/Translate"

const { TEXT_T712 } = Translate

export const getValueOrUndecided = (value: string) =>
  value ? value : TEXT_T712
